import { Controller } from "@hotwired/stimulus"

// The post preview card (live/_share_post_card): counts the text against the
// tightest cross-post limit (Bluesky counts graphemes, so an emoji is one),
// marks the card dirty so the chat poll keeps what was typed, and keeps the
// submit buttons from double-firing.
export default class extends Controller {
    static targets = ["body", "count"]
    static values = { limit: Number, network: String }

    connect() {
        this._segmenter = window.Intl?.Segmenter ? new Intl.Segmenter(undefined, { granularity: "grapheme" }) : null
        this._render()
        this.element.addEventListener("turbo:submit-start", () => this._setDisabled(true))
        this.element.addEventListener("turbo:submit-end", () => setTimeout(() => this._setDisabled(false), 600))
    }

    changed() {
        this.element.dataset.liveCardDirty = "true"
        this._render()
    }

    _render() {
        if (!this.hasCountTarget) return
        const text = this.bodyTarget.value
        const length = this._segmenter ? Array.from(this._segmenter.segment(text)).length : Array.from(text).length
        if (!this.limitValue) {
            this.countTarget.textContent = `${length} characters`
            return
        }
        const over = length - this.limitValue
        this.countTarget.textContent = over > 0 ? `${over} over ${this.networkValue}'s ${this.limitValue} - it will be cut there` : `${length} / ${this.limitValue} for ${this.networkValue}`
        this.countTarget.classList.toggle("post-card-count--over", over > 0)
    }

    _setDisabled(disabled) {
        this.element.querySelectorAll(".event-card-footer button").forEach((button) => { button.disabled = disabled })
    }
}
